import { Environment, TimeTools, UserInfo } from "./libs/statics";
import { Setup } from './libs/setup';
import { Pager } from "./libs/pager.class";
import { API } from './libs/api';
import { ALERT } from './libs/alerts';
import { Forms } from "./gadgets/forms";
import { LogPage } from "./pages/logs.page";
import { UserPage } from "./pages/users.page";
import { ProfilePage } from "./pages/profile.page";
import { RoleMgPage } from "./pages/rolemg.page";
console.log("Welcome to rufus!!!");
Pager.setBlankPage();
var headParam = /\:([\w\:\@]+)/gm;
var headerData = window.location.href.split(headParam);
var headerObject = headerData.length > 1 ? headerData[1].split(':') : [];
var page = headerObject.length > 0 ? headerObject[0] : "home";
headerObject.shift();
var header = {
    page: page,
    data: headerObject
};
var Main = function (obj) {
    UserInfo.init(obj);
    Pager.setup(new Map([
        ["log_list", LogPage],
        ["users", UserPage],
        ["profile", ProfilePage],
        ["role_mgr", RoleMgPage],
    ]));
    Pager.loadPage(header.page, true);
    TimeTools.createTTLEvent("#timeToLife");
    Setup.AddAdminPanel();
    $('[data-username]').text(UserInfo.firstname + " " + UserInfo.surname);
    $('#blankscreen').fadeOut('fast');
};
var tmp = sessionStorage.getItem("ssid");
var command = "auth";
if (tmp && tmp != '') {
    Environment.ssid = tmp;
    command += "?ssid=" + Environment.ssid;
}
$.getJSON("env.json", function (env) {
    API.uri = env.api_uri;
    Environment.uri = API.uri;
    //console.log(command)
    API.get(command, function (authState) {
        Environment.ssid = authState.ssid;
        sessionStorage.setItem("ssid", authState.ssid);
        // console.log(Environment.ssid)
        // console.log(command)
        if (authState.has_data) {
            var o = authState.data.auth_state;
            // console.log(authState)
            // console.log(env.api_uri)
            // console.log(API.uri)
            if (o[0] == "REQ_AUTH") {
                $('#lockicon').show();
                var login = "<form action=\"index.html\" method=\"GET\"><div class=\"form-floating mb-20px\"><input type=\"text\" class=\"form-control fs-13px h-45px border-0\" placeholder=\"E-Mail\" id=\"email\" /><label for=\"email\" class=\"d-flex align-items-center text-gray-600 fs-13px\">Email Address</label></div><div class=\"form-floating mb-20px\"><input type=\"password\" class=\"form-control fs-13px h-45px border-0\" placeholder=\"Passwort\" id=\"password\" /><label for=\"password\" class=\"d-flex align-items-center text-gray-600 fs-13px\">Password</label></div><div class=\"mb-20px\"><button id=\"btnLogin\" type=\"submit\" class=\"btn btn-theme d-block w-100 h-45px btn-lg\">Anmelden</button></div></form>";
                $('#lg_content').html(login);
                $('#btnLogin').on('click', function (evt) {
                    $('#btnLogin').html('<span class="loader"></span>');
                    $('#btnLogin').prop("disabled", true);
                    evt.preventDefault();
                    var email = $('#email').val();
                    var pass = $('#password').val();
                    var data = { func: "auth", email: email, passwd: pass, totpkey: "" };
                    var login = function (ssid) {
                        var command = "auth";
                        if (ssid && ssid != '') {
                            Environment.ssid = ssid;
                            command += "?ssid=" + Environment.ssid;
                        }
                        $.post(API.uri + command, data, function (result) {
                            if (result.has_data) {
                                if (result.data.auth_success !== undefined) {
                                    Main(result.data.auth_success);
                                }
                                else {
                                    console.log(result);
                                    if (result.data.auth_totp !== undefined) {
                                        $('.totpinput').remove();
                                        var forms = new Forms();
                                        $('#btnLogin').closest("div").prepend(forms.totpInputs());
                                        $('[data-totp-input="1"]').trigger('focus');
                                        forms.totpListenEvent(function (val) {
                                            data['totpkey'] = val;
                                            login(Environment.ssid);
                                        });
                                    }
                                    else {
                                        if (result.ssid !== undefined && result.ssid != '' && result.ssid != Environment.ssid) {
                                            Environment.ssid = result.ssid;
                                            sessionStorage.setItem("ssid", result.ssid);
                                            login(Environment.ssid);
                                        }
                                        $('#btnLogin').prop("disabled", false);
                                        $('#btnLogin').html('Login');
                                    }
                                }
                            }
                            else {
                                $('.totpinput').remove();
                                $('#btnLogin').prop("disabled", false);
                                $('#btnLogin').html('Login');
                                ALERT.showSimple("Ooops!", "E-Mail Addresse, Passwort oder das Einmalpasswort falsch!", "error");
                            }
                        }, "json");
                    };
                    login(Environment.ssid);
                });
            }
            else if (o[0] == "AUTH_OK") {
                Main(o[1]);
            }
            else {
                console.log("Unbekannter fehler!");
            }
        }
        else {
            var m = authState.messages;
            if (m.length > 0) {
                $('#lg_content').html("<div class=\"note alert-danger\"><div class=\"note-content\"><h4><b>Ein Fehler ist aufgetreten</b></h4><p>".concat(m[0].text, "</p></div></div>"));
            }
        }
    });
});
$('[data-logout-btn]').on('click', function (evt) {
    evt.preventDefault();
    $.getJSON(API.uri + "logout?ssid=" + Environment.ssid, function (result) {
        if (result.has_data && result.data.STATE == "OK") {
            sessionStorage.clear();
            location.reload();
        }
    });
});
